import { Pipe, PipeTransform } from "@angular/core";
import { sortBy } from "lodash";

@Pipe({
  name: "orderBy"
})

export class OrderByPipe implements PipeTransform {
  transform(array: Array<any>, args?: any): any {
    return sortBy(array, [args]);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/order-by.pipe.ts